module.exports = __webpack_public_path__ + "./images/pdf-thumbnail.e3b248.jpg";